import React from 'react';
import { Link } from 'react-router-dom';

import { Text } from '../atom/Text';
import { Anchor } from '../atom/Anchor';
import ThemeStyle from '../../../lib/style/ThemeStyle';

export const TextLink = ({
  link = '',
  size = ThemeStyle.typography.size,
  weight = ThemeStyle.typography.weight,
  color = ThemeStyle.color,
  withUnderline = false,
  children,
  ...props
}) => {
  const onUnderline = () =>
    withUnderline && {
      color: ThemeStyle.color[color],
      textDecoration: 'underline',
      textUnderlineOffset: '1px',
    };

  const LinkComponent = ({ children }) =>
    link.includes('http') ? (
      <Anchor link={link} style={{ ...onUnderline() }}>
        {children}
      </Anchor>
    ) : (
      <Link to={link} style={{ ...onUnderline() }}>
        {children}
      </Link>
    );

  return (
    <LinkComponent>
      <Text color={color} weight={weight} size={size} {...props}>
        {children}
      </Text>
    </LinkComponent>
  );
};

export const TextLinkWithVerticalLine = ({
  list = [{ text: '', link: '' }],
  color = ThemeStyle.color,
  size = ThemeStyle.typography.size,
  weight = ThemeStyle.typography.weight,
  ...props
}) => (
  <Text size={size} color={color} {...props}>
    {list.map((item) => (
      <TextLink key={item.text} link={item.link} color={color} size={size}>
        {item.text}
        {item !== list[list.length - 1] && ` | `}
      </TextLink>
    ))}
  </Text>
);

TextLinkWithVerticalLine.defaultProps = {
  size: 14,
  color: 'brownGrey',
  weight: 'regular',
};
